import axios from "axios";
import { useTemplateStore } from "@/stores/template";
import commonUtils from "@/utils/commonUtils"; // 请求拦截

// 请求拦截
axios.interceptors.request.use(
  (req) => {
    return Promise.resolve(req);
  },
  (error) => {
    return Promise.reject(error);
  }
);

let params = null;
// 响应拦截
axios.interceptors.response.use(
  (res) => {
    return Promise.resolve(res);
  },
  (error) => {
    if (error.response && error.response.status === 403) {
      const templateStore = useTemplateStore();
      templateStore.pageLoader({ mode: "off" });
      const query = JSON.parse(sessionStorage.getItem("routeInfo"));

      let baseUrl = "/#/security/sign-in?";
      // window.location.href = "/#/security/sign-in?";
      window.location.href = "/#/security/sign-in";
      let other = null;
      if (query) {
        for (const queryKey in query) {
          other = queryKey + "=";
          baseUrl += other + query[queryKey];
        }
      }
      // window.location.query = query;
    } else if (error.response && error.response.status === 504) {
      //超时的时候把加载框关闭
      const templateStore = useTemplateStore();
      templateStore.pageLoader({ mode: "off" });

      commonUtils.openToastBox(
        "ERROR",
        "Error",
        "Request timed out. Please try again"
      );
    } else if (error.response && error.response.status === 500) {
      //超时的时候把加载框关闭
      const templateStore = useTemplateStore();
      templateStore.pageLoader({ mode: "off" });

      commonUtils.openToastBox("ERROR", "Error", "Request failed!");
    }
    //登录页登录失败的情况
    else {
      return Promise.reject(error.response);
    }
    // return Promise.resolve();
  }
);

export default axios;
